import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Formik, FormikHelpers } from 'formik';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

import { ResearchSheet } from 'types';
import { PageKey, ProofOfIdentityType } from 'enums';
import {
  BreadcrumbsCtx,
  initialBreadcrumbs,
} from 'components/portfolio/breadcrumbs-ctx';
import { NotificationCtx } from 'components/notification/notification-hook';
import { NotificationVariant } from 'components/notification/notification-types';
import { AuthCtx } from 'components/auth/auth-ctx';

import { postResearchSheetNew } from './research-sheet-api';
import { ResearchSheetBasic } from './research-sheet-basic';
import { validationSchemaNew } from './research-sheet-validation';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
    },
    form: {
      color: 'black',
      marginBottom: 50,
    },
  })
);

export function ResearchSheetNew() {
  const classes = useStyles();
  const { setBreadcrumbs } = useContext(BreadcrumbsCtx);
  const { userLoaded } = useContext(AuthCtx);
  const { showNotification } = useContext(NotificationCtx);
  const history = useHistory();

  const handleSubmit = async (
    values: ResearchSheet,
    actions: FormikHelpers<ResearchSheet>
  ) => {
    try {
      const response = await postResearchSheetNew(values);

      if (response) {
        showNotification('Žádost odeslána.', NotificationVariant.SUCCESS);

        history.push('/portfolio/badatelske-listy');

        actions.resetForm();
      }
    } catch (e) {
      showNotification(
        'Žádost se nezdařilo odeslat.',
        NotificationVariant.ERROR
      );
    }

    actions.setSubmitting(false);
  };

  useEffect(() => {
    setBreadcrumbs([
      ...initialBreadcrumbs.breadcrumbs,
      {
        title: 'Žádost o BL',
        key: PageKey.PORTFOLIO_RESEARCH_SHEET_NEW,
      },
    ]);
  }, [setBreadcrumbs]);

  const initialValues = userLoaded
    ? ({
        proofOfIdentityType: ProofOfIdentityType.CAS,
      } as ResearchSheet)
    : ({} as ResearchSheet);

  return (
    <Grid container className={classes.container}>
      <Grid item xs={10} md={8}>
        <div className={classes.form}>
          <Formik<ResearchSheet>
            initialValues={initialValues}
            onSubmit={handleSubmit}
            enableReinitialize={true}
            validateOnChange={false}
            validateOnBlur={false}
            validateOnMount={false}
            validationSchema={validationSchemaNew}
          >
            {ResearchSheetBasic}
          </Formik>
        </div>
      </Grid>
    </Grid>
  );
}
